<section>
	<div class="container container">
		<div
			class="col-xxl-12 col-xl-11 col-lg-11 col-md-11 col-sm-11 col-11 mx-auto"
		>
			<div class="banner vh-100">
				<div
					class="d-flex flex-column justify-content-center h-100 align-items-start"
					style="backface-visibility: hidden"
				>
					<div class="contentbl">
						<h1 class="light size90 textcolor1">
							Creativity. Identity. Visual.
							<span class="barcely">Soul</span>. Brand. Customer
						</h1>
					</div>
				</div>
				<!-- <div
					class="d-flex flex-column justify-content-center align-items-start h-100"
				>
					
					<div class="mblwd">
            desktop
            <h2 class="d-none d-sm-block d-md-block d-lg-block d-xl-block d-xxl-block h1  size90" data-aos="fade-up"
              data-aos-duration="1000" data-aos-delay="100"> Creativity.Identity.</h2>
            <h2 class="d-none d-sm-block d-md-block d-lg-block d-xl-block d-xxl-block h1  size90" data-aos="fade-up"
              data-aos-duration="1500" data-aos-delay="200"> Visual.<span class="barcelony text-color">Soul</span><span
                class="text-color">.</span>Brand.</h2>
            <h2 class="d-none d-sm-block d-md-block d-lg-block d-xl-block d-xxl-block h1  size90" data-aos="fade-up"
              data-aos-duration="2000" data-aos-delay="300"> Customer </h2>
            desktop
            mobile
            <h2 class="d-block d-sm-none d-md-none d-lg-none d-xl-none d-xxl-none h1  size90" data-aos="fade-up"
              data-aos-duration="1000" data-aos-delay="100"> Creativity.</h2>
            <h2 class="d-block d-sm-none d-md-none d-lg-none d-xl-none d-xxl-none h1  size90" data-aos="fade-up"
              data-aos-duration="1000" data-aos-delay="200"> Identity.</h2>
            <h2 class="d-block d-sm-none d-md-none d-lg-none d-xl-none d-xxl-none h1  size90" data-aos="fade-up"
              data-aos-duration="1500" data-aos-delay="300"> Visual.<span class="barcelony text-color">Soul</span><span
                class="text-color">.</span></h2>
            <h2 class="d-block d-sm-none d-md-none d-lg-none d-xl-none d-xxl-none h1  size90" data-aos="fade-up"
              data-aos-duration="2000" data-aos-delay="400">Brand.</h2>
            <h2 class="d-block d-sm-none d-md-none d-lg-none d-xl-none d-xxl-none h1  size90" data-aos="fade-up"
              data-aos-duration="2500" data-aos-delay="500"> Customer </h2>
            mobile
          </div>
				</div> -->
			</div>
			<div class="position-absolute banner-left-content">
				<p>Whether it's a birth or an evolution of a brand,</p>
				<p>nothing stands out unless it has a soul.</p>
			</div>
		</div>
	</div>
</section>
<section class="pb-0">
	<div class="container-md container-fluid-sm">
		<div class="col-lg-10 offset-lg-1">
			<div class="img-block d-flex justify-content-center">
				<img
					src="{{ baseUrl }}/img/about-us/pixtar-diagram-1-wiggle.gif"
					alt="Pixtar process"
					width=""
					height=""
					loading="lazy"
				/>
				<div
					class="content d-flex flex-column position-absolute startl-31"
					data-aos="fade-up"
					data-aos-duration="2000"
					data-aos-delay="100"
				>
					<h2 class="size55 textcolor5">Research</h2>
					<p>
						We start every project by reviewing and analyzing industry
						Competitor, relevant projects and sustainable references. Feedback
						to the client for continual input for both parties.
					</p>
				</div>
			</div>
			<div class="img-block d-flex justify-content-center">
				<div
					class="content d-flex flex-column position-absolute startr-31"
					data-aos="fade-up"
					data-aos-duration="2000"
					data-aos-delay="100"
				>
					<h2 class="size55 textcolor5">Strategy</h2>
					<p>
						Each project starts with a thorough investigation of the client's
						business, analysis of it's key features & definition of the optimal
						strategy for developing it.
					</p>
				</div>
				<img
					src="{{ baseUrl }}/img/about-us/pixtar-diagram-2.gif"
					alt="evolution of a brand"
					width=""
					height=""
					loading="lazy"
				/>
			</div>

			<div class="img-block d-flex justify-content-center">
				<img
					src="{{ baseUrl }}/img/about-us/pixtar-diagram-3.gif"
					alt="design thinking for innovation"
					width=""
					height=""
					loading="lazy"
				/>
				<div
					class="content d-flex flex-column position-absolute startl-31"
					data-aos="fade-up"
					data-aos-duration="2000"
					data-aos-delay="100"
				>
					<h2 class="size55 textcolor5">Design</h2>
					<p>
						Impeccable design can make or break a brand: we create detailed mood
						boards, wireframes and define user flows & then we experiment with
						the visuals using a style guide as the basis until we reach a fully
						responsive, flawless output.
					</p>
				</div>
			</div>

			<div class="img-block d-flex justify-content-center">
				<div
					class="content d-flex flex-column position-absolute startr-31"
					data-aos="fade-up"
					data-aos-duration="2000"
					data-aos-delay="100"
				>
					<h2 class="size55 textcolor5">Development</h2>
					<!-- <p>Once the decision is made in which direction to develop, a more refined concept will be presented to the client. We will also discuss in more detail print materials, online functions and features and applying a thorough 2-step QA process to our already consistent coding process. The combination of these rules allows us to deliver the best solution for each challenge, every time.</p> -->
					<p>
						Once the decision is made in which direction to develop, a more
						refined concept will be presented to the client. We will also
						discuss in more detail print materials, online functions & features
						and applying a thorough 2-step QA process to our consistent coding
						process.
					</p>
				</div>
				<img
					src="{{ baseUrl }}/img/about-us/pixtar-diagram-4.gif"
					alt="Strategy for Design Process"
					width=""
					height=""
					loading="lazy"
				/>
			</div>

			<div class="img-block d-flex flex-row justify-content-center">
				<img
					src="{{ baseUrl }}/img/about-us/pixtar-diagram-5.gif"
					alt="Step-by-Step Creative Workflow"
					width=""
					height=""
					loading="lazy"
				/>
				<div
					class="content d-flex flex-column position-absolute startl-31"
					data-aos="fade-up"
					data-aos-duration="2000"
					data-aos-delay="100"
				>
					<h2 class="size55 textcolor5">Delivery</h2>
					<p>
						The final solution will be delivered, hitting the deadline. we like
						to develop a relationship with our clients and provide them an
						ongoing design service for this current project and more.
					</p>
				</div>
			</div>
		</div>
		<div class="help-block">
			<img
				src="{{ baseUrl }}/img/about-us/white-down-arrow.svg"
				alt="Creative Agency Process"
				height="70"
				width=""
				loading="lazy"
			/>
			<div
				class="d-flex flex-column justify-content-center align-items-center cstpadding"
				data-aos="fade-up"
				data-aos-duration="2000"
				data-aos-delay="100"
			>
				<p class="mb-0 p40">Support</p>
				<h2 class="mt-0 p90">
					We <span class="barcelony text-color">keep helping</span> you
				</h2>
				<h2 class="mt-0 p90">
					As long as <span class="barcelony text-color">you</span> need us
				</h2>
			</div>
		</div>
	</div>
</section>
<!-- <section>
  <div class="container">
    <div class="row">
      <div class="col-md-12">
        <div class="help-block">
          <div class="d-flex flex-column justify-content-center align-items-center">
            <p class="mb-0">Support</p>
            <h2 class="mt-0">We keep helping you As long </h2>
            <h2 class="mt-0">As you need us</h2>
          </div>
        </div>
      </div>
    </div>
  </div>
</section> -->
<div class="line"></div>
